import React, { Component } from 'react';
import '../../../style/animation/loading.scss';
import _ from 'lodash';
import { loaderService } from '../../services/loader-services';
import { Subscription } from 'rxjs';

interface ILoadingProps {
  scale?: number;
  overrideStyle?: any;
  showLoadingBackground?: boolean;
}

interface ILoadingStates {
  style: any;
  showSpinner?: boolean;
  showLoadingBackground?: boolean;
}

class Loading extends Component<ILoadingProps, ILoadingStates> {
  private loadingSubscription: Subscription | undefined;

  constructor(props: ILoadingProps) {
    super(props);
    const overrideStyle = {
      transform: 'scale(' + this.props.scale + ')',
      WebkitTransform: 'scale(' + this.props.scale + ')',
      msTransform: 'scale(' + this.props.scale + ')',
      MozTransform: 'scale(' + this.props.scale + ')',
      OTransform: 'scale(' + this.props.scale + ')',
    };
    if (!_.isEmpty(this.props.overrideStyle)) {
      Object.assign(overrideStyle, this.props.overrideStyle);
    }
    this.state = {
      style: overrideStyle,
      showSpinner: false,
      showLoadingBackground: false
    };
  }

  public componentDidMount() {
    if (!window.HTML_RENDITION.initialData.showOldLoading) {
      this.loadingSubscription = loaderService.getLoadingSubj().subscribe((obj: any) => {
        this.setState(obj);        
      })   
    } else {   
      this.setState({showSpinner: true});
    }        
  } 
  
  componentWillUnmount() {
    if (!window.HTML_RENDITION.initialData.showOldLoading) {
      if (this.loadingSubscription) {
          this.loadingSubscription.unsubscribe();
      }
      loaderService.getLoadingSubj().next({showSpinner: false});
      loaderService.getLoadingSubj().next({showLoadingBackground: false});      
    }
  }

  public render() {
    return (
      <React.Fragment>
        <div className={this.state.showSpinner? 'lds-spinner': ''} style={this.state.style}>
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
        {(this.props.showLoadingBackground || this.state.showLoadingBackground) &&
          <div className='loading-bg' style={{zIndex: 1040, backgroundColor: '#000', opacity: 0.2}}/>
        }
      </React.Fragment>);
  }
}

export default Loading;
